import { selectedEntriesSelector, listViewEntriesSelector } from '../../../selectors/admin/models/lineup';
import { filter, remove } from 'lodash';
import { apiMultipleCalls } from '../../helpers';
import { ADMIN_MODAL_FORMS } from '../../../constants/actions';
import { performances, partners } from '../../../services/api.admin';
import { fetchLineup } from './lineup';
import { fetchDependencies } from '../modal.forms';

export function bulkUpdatePerformances(data, modelId) {
    return (dispatch, getState) => {
        const selected = selectedEntriesSelector(getState());
        const entries = filter(listViewEntriesSelector(getState()), (x) => selected.includes(x.id));
        dispatch({ type: ADMIN_MODAL_FORMS.SUBMIT });
        apiMultipleCalls(
            dispatch,
            entries.map((e) => () =>
                performances.put(e.id, {
                    artistId: e.artistId,
                    stageId: e.stageId,
                    clearing: _setClearing(e.clearing, data),
                })
            ),
            () => {
                dispatch({ type: ADMIN_MODAL_FORMS.SUCCESS });
                dispatch(fetchLineup(modelId));
            }
        );
    };
}

const _setClearing = (current, data) => {
    const partners = [...data.partners];
    const clearing = current.map((x) => ({
        ...x,
        [data.type]: partners.includes(x.partnerId)
            ? remove(partners, (p) => p === x.partnerId) && data[data.type]
            : x[data.type],
    }));
    partners.forEach((p) =>
        clearing.push({
            partnerId: p,
            comments: '',
            live: '',
            nonLinear: '',
            useUntil: 0,
            [data.type]: data[data.type],
        })
    );
    return clearing;
};

export function fetchBulkPerformancesDependency(_, eventId) {
    return fetchDependencies([() => partners.getAllForEvent(eventId)]);
}



// WEBPACK FOOTER //
// ./src/actions/admin/models/bulk.js